import React from 'react';
import {
  TextField,
  Styles,
  FlatButton,
  Paper,
  LinearProgress, Toggle
} from 'material-ui';
import FileSelectorDialog from 'components/Widgets/FileSelectorDialog';
import DropZone from 'components/DropZone';
import { FormattedMessage } from 'react-intl';
import dropZoneStyles from 'components/Page/Module/Styles';
import CircularProgress from 'components/Material/CircularProgress';
import { FlexBox } from 'components';
import Embed from 'components/Page/Module/Embed';
import SteelCompass from 'services/SteelCompass';
import SuperAgent from 'superagent';
import Config from 'Config';
import * as Icons from 'components/Material/SvgIcons';
import PageModule from 'components/PageModule';
import { Media } from 'Util';
import SoundCloud from 'services/SoundCloud';
import Message from 'services/Message';
import { Units } from 'Css';

const { Spacing } = Styles;

const styles = {
  audio: {
    width: '100%'
  }
};

const css = oxygenCss({
  toggleWrapper: {
    padding: `${Units.base}px ${Units.base * 3}px`
  },
});

const supportedExtensions = ['mp4'];

class AudioModule extends PageModule {
  static readable = 'AudioModule';

  constructor() {
    super(...arguments);
    const { content, params } = this.props;
    const { caption, external, allowDownloading, file_id } = params;
    let file;
    let sources = [];
    if (content.length && content.length > 0) {
      file = content[0];
      sources =
        (file &&
          supportedExtensions.map(extension => {
            return { url: file.url + '.' + extension, type: extension };
          })) ||
        [];
    } else if (
      params &&
      typeof params === 'object' &&
      Object.keys(params).length > 0 &&
      !params.external
    ) {
      sources = Object.keys(params).map(extension => {
        return { url: params[extension], type: extension };
      });
    }
    // const sources = [{ url: file.url, type: file.url.split('.').pop() }];

    this.state = {
      edit: {
        sources,
        external,
        caption,
        allowDownloading,
        fileId: file_id ? file_id[0] : null,
      }
    };
  }

  controlsList() {
    const { allowDownloading, fileId } = this.state.edit;
    const audioPlayer = document.getElementById(`${fileId}`);

    if (audioPlayer && (allowDownloading && audioPlayer.hasAttribute('controlsList'))) {
      audioPlayer.removeAttribute('controlsList')
    }
    if (audioPlayer && (!allowDownloading && !audioPlayer.hasAttribute('controlsList'))) {
      audioPlayer.setAttribute('controlsList', 'nodownload')
    }
  }

  componentDidMount() {
    this.controlsList();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.params.allowDownloading !== prevState.edit.allowDownloading) {
      this.controlsList();
    }
  }

  selectMedia(file) {
    const sources = supportedExtensions.map(extension => {
      return { url: file.url, type: extension };
    });
    const edit = {
      ...this.state.edit,
      fileId: file.id,
      external: null,
      sources
    };
    this.setState({ edit, fileSelectorOpen: false });
    // this.autoSave();
  }

  progress(event) {
    this.setState({ progress: event.percent });
  }

  onMediaLibrary() {
    this.setState({ fileSelectorOpen: true });
  }

  onMediaLibraryClose() {
    this.setState({ fileSelectorOpen: false });
  }

  openDownload(event) {
    this.refs.dropZone.open();
    event.stopPropagation();
    event.preventDefault();
  }

  changeCaption(e) {
    const edit = {
      ...this.state.edit,
      caption: e.target.value
    };
    this.setState({ edit });
  }

  saveOnBlur() {
    Message.info(this.context.getIntlMessage('video.changesSaved'));
    this.save(false);
  }

  allowDownloading = (event, allowDownloading) => {
    this.setState(
        {
          edit: {
            ...this.state.edit,
            allowDownloading
          }
        },
    );
  };

  getModuleData(content, data) {
    return {
      caption: this.state.edit.caption,
      allowDownloading: this.state.edit.allowDownloading,
      fileId: this.state.edit.fileId || data.fileId,
      external: this.state.edit.external
    };
  }

  embed() {
    const url = this.refs.embedUrl.value;
    const provider = Media.getProviderFromUrl(url);
    const edit = {
      ...this.state.edit
    };
    if (provider.provider === 3) {
      SoundCloud.oEmbed(url, response => {
        provider.id = response.html;
        edit.external = provider;
        this.setState({ edit });
        this.autoSave();
      });
    } else {
      edit.external = provider;
      this.setState({ edit });
      this.autoSave();
    }
  }

  attach(data) {
    if (data.length && data.length > 0) {
      const file = data[0].file;
      const sources = supportedExtensions.map(extension => {
        return { url: file.url,
              type: extension };
      });
      const edit = {
        ...this.state.edit,
        external: null,
        fileId: file.id,
        sources
      };
      this.setState({ edit });
      this.getModuleData();
      this.pollApiForJobId(file.id);
    }
  }

  autoSave() {
    if (this._timer) {
      clearTimeout(this._timer);
    }
    this._timer = setTimeout(() => {
      Message.info(this.context.getIntlMessage('video.changesSaved'));
      this.save(false);
      this._timer = null;
    }, 1000);
  }

  pollApiForJobId(fileId) {
    if (!this.state.pollProgress) {
      this.setState({ pollProgress: true });
    }
    setTimeout(() => {
      const now = new Date();
      this.apiPollerStart = this.apiPollerStart || new Date();
      if (now - this.apiPollerStart < 100000) {
        SteelCompass.call('file', 'getJobId', { fileId: fileId }, async response => {
          const data = response.data;
          // Poll encoding progress
          if (data && data.jobId && data.accessKey) {
            await this.pollZencForProgress(data.jobId, data.accessKey);
          } else {
            // Keep polling for jobId
            this.pollApiForJobId(fileId);
          }
        });
      } else {
        // Reset polling
        this.apiPollerStart = null;
      }
    }, 5000);
  }

  pollZencForProgress(jobId, accessKey) {
    this.setState({ progress: 0, pollProgress: false });
    setTimeout(async () => {
      const now = new Date();
      this.zencPollerStart = this.zencPollerStart || new Date();
      if (
        now - this.zencPollerStart < 100000 ||
        (this.encodingProgress > 0 && this.encodingProgress < 100)
      ) {
        const response = await SuperAgent.get(
          Config.zenCoderRoot +
            'jobs/' +
            jobId +
            '/progress.json?api_key=' +
            accessKey
        )
          .set('Content-Type', 'text/plain')

        const data = (response && JSON.parse(response.text)) || {};
        // Data object should contain a state and a progress property if the state is still processing.
        if (data.state === 'processing' && data.progress) {
          if (data.progress > this.state.progress) {
            this.setState({ progress: data.progress });
          }
          await this.pollZencForProgress(jobId, accessKey);
        } else if (data.state === 'finished') {
          // Stop the polling
          const sources = this.state.edit.sources.map(source => {
            return {
              ...source,
              url: source.url,
            };
          });
          this.setState({
            progress: 100,
            pollProgress: false,
            edit: {
              ...this.state.edit,
              sources
            }
          });
          Message.info(this.context.getIntlMessage('media.encodingComplete'));
        }
      } else {
        // Reset polling
        this.zencPollerStart = null;
        this.autoSave();
      }
    }, 2000);
  }

  renderEditMode() {
    const { sources, external, caption, allowDownloading } = this.state.edit;
    const audioSources = sources.map(source => {
      if (typeof source.url === 'string') {
        return (
            <source
                src={source.url.split('.')[source.url.split('.').length - 1] === source.type ?
                    source.url
                    :
                    `${source.url}.${source.type}`}
                type={'audio/' + source.type}
                key={source.type}
            />
        );
      } else {
        return (<source
            src={source.url}
            type={'audio/' + source.type}
            key={source.type}
        />)
      }
    });

    let audio;

    let pollProgress;
    if (this.state.pollProgress) {
      pollProgress = (
        <LinearProgress
          style={{ height: Spacing.desktopKeylineIncrement / 4 }}
          mode="indeterminate"
        />
      );
    }

    const uploadLink = (
      <a onTouchTap={::this.openDownload}>
        {this.context.getIntlMessage('module.upload')}
      </a>
    );
    const libraryLink = (
      <a onTouchTap={::this.onMediaLibrary}>
        {this.context.getIntlMessage('module.library')}
      </a>
    );
    if (this.state.progress > 0 && this.state.progress < 100) {
      audio = (
        <CircularProgress
          progressColor={this.context.muiTheme.rawTheme.palette.primary1Color}
          progress={this.state.progress}
          size={2}
        />
      );
    } else if (sources.length > 0 || (external && external.provider)) {
      if (external && external.provider) {
        audio = <Embed params={external} />;
      } else {
        audio = (
          <audio controls style={styles.audio}>
            {audioSources}
          </audio>
        );
      }
    } else {
      audio = <Icons.AvMovie style={dropZoneStyles.icon} />;
    }

    return (
      <div>
        <div style={dropZoneStyles.moduleContainer}>
          {audio}
          {pollProgress}
        </div>
        <DropZone
          accept="audio/*"
          ref="dropZone"
          style={dropZoneStyles.dropZone}
          lineHeight={Spacing.desktopKeylineIncrement / 2}
          onProgress={::this.progress}
          onSuccess={::this.attach}
        >
          <div style={dropZoneStyles.header}>
            {this.context.getIntlMessage('module.dropAudio')}
          </div>
          <div style={dropZoneStyles.subHeader}>
            <FormattedMessage
              message={this.context.getIntlMessage('module.uploadOrBrowse')}
              upload={uploadLink}
              library={libraryLink}
            />
          </div>
          <div style={dropZoneStyles.subHeader}>
            {this.context.getIntlMessage('module.or')}
          </div>
          <Paper style={dropZoneStyles.import.root}>
            <FlexBox>
              <FlexBox>
                <input
                  ref="embedUrl"
                  style={dropZoneStyles.import.input}
                  type="text"
                  placeholder={this.context.getIntlMessage('audio.embed')}
                  onChange={::this.embed}
                />
              </FlexBox>
            </FlexBox>
          </Paper>

          <TextField
            fullWidth
            hintText={this.context.getIntlMessage('Caption')}
            value={caption}
            onChange={::this.changeCaption}
            // onBlur={::this.saveOnBlur}
          />
        </DropZone>
        <div className={css.toggleWrapper}>
          <Toggle
              name={'allowDownloading'}
              value={'allowDownloading'}
              labelPosition={'right'}
              defaultToggled={allowDownloading}
              label={this.context.getIntlMessage('video.allowDownloading')}
              onToggle={this.allowDownloading}
          />
        </div>
        <FileSelectorDialog
          type="audio"
          open={this.state.fileSelectorOpen}
          onSelect={::this.selectMedia}
          onClose={::this.onMediaLibraryClose}
        />
      </div>
    );

    // return (
    //   <div>
    //     <DropZone accept="audio/*" ref="dropZone" style={dropZoneStyles.dropZone} lineHeight={Spacing.desktopKeylineIncrement / 2} onProgress={this.progress} onSuccess={this.attach}>
    //       <div style={dropZoneStyles.moduleContainer}>{audio}</div>
    //       <div style={dropZoneStyles.header}>{this.context.getIntlMessage('module.dropAudio')}</div>
    //       <div style={dropZoneStyles.subHeader}>
    //         <FormattedMessage message={this.context.getIntlMessage('module.uploadOrBrowse')} upload={uploadLink} library={libraryLink} />
    //       </div>
    //       <div style={dropZoneStyles.subHeader}>
    //         {this.context.getIntlMessage('module.or')}
    //       </div>
    //       <Paper style={styles.import.root}>
    //         <input ref="embedUrl" style={styles.import.input} type='text' placeholder={this.getIntlMessage('audio.embed')} value={this.state.embedUrl} onChange={this.embed}/>
    //         <FlatButton secondary={true} label={this.getIntlMessage('Embed')} onTouchTap={this.embed}/>
    //       </Paper>

    //       <TextField fullWidth={true} floatingLabelText={this.getIntlMessage('Caption')} value={this.state.caption} onChange={this.changeCaption}/>
    //     </DropZone>

    //   </div>
    // );
  }

  renderDetailMode() {
    const { sources, caption, external, fileId } = this.state.edit;

    let audio;

    if (external && external.provider) {
      audio = <Embed params={external} />;
    } else if (sources && sources.length > 0) {
      const audioSources = sources.map(source => {
        if (typeof source.url === 'string') {
          return (
              <source
                  src={source.url.split('.')[source.url.split('.').length - 1] === source.type ?
                      source.url
                      :
                      `${source.url}.${source.type}`}
                  type={'audio/' + source.type}
                  key={source.type}
              />
          );
        } else {
          return (<source
              src={source.url}
              type={'audio/' + source.type}
              key={source.type}
          />)
        }
      });
      audio = (
        <audio id={fileId} controls style={styles.audio}>
          {audioSources}
          <figcaption>{caption}</figcaption>
        </audio>
      );
    } else {
      audio = (
        <div style={dropZoneStyles.dropZone}>
          <div style={dropZoneStyles.moduleContainer}>
            <Icons.ImageAudiotrack style={dropZoneStyles.icon} />
            <br />
            {this.context.getIntlMessage('module.uploadAudio')}
          </div>
        </div>
      );
    }
    return (
      <div>
        {audio}
        <figcaption>{caption}</figcaption>
      </div>
    );
  }
}

export default AudioModule;



// WEBPACK FOOTER //
// ./src/js/components/Page/Module/Audio.js